export default "__VITE_ASSET__BGgdW3e2__"